var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.hide-password-svg .st0{fill:#020203;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hide-password-svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,17.5l4-5.7c0.9-1.3,0.6-3.1-0.7-4c-1.3-0.9-3.1-0.6-4,0.7L41,15.2c-2.9-0.9-5.9-1.5-9-1.5 C14.3,13.6,0,32,0,32s7.5,9.6,18.4,14.9l-3.7,5.3c-0.9,1.3-0.6,3.1,0.7,4c0.5,0.4,1.1,0.5,1.7,0.5c0.9,0,1.8-0.4,2.4-1.2l4.6-6.4 c2.6,0.8,5.2,1.3,8,1.3C49.7,50.4,64,32,64,32S56.9,22.9,46.5,17.5z M7.8,32c4.7-4.8,14.1-12.6,24.2-12.6c1.9,0,3.7,0.3,5.5,0.7 l-2.6,3.6C34,23.4,33,23.2,32,23.2c-4.9,0-8.8,3.9-8.8,8.8c0,2.1,0.7,4,1.9,5.5l-3.3,4.7C15.9,39.5,10.9,35.1,7.8,32z M32,44.6 c-1.5,0-3-0.2-4.4-0.5l2.5-3.5c0.6,0.1,1.3,0.2,1.9,0.2c4.9,0,8.8-3.9,8.8-8.8c0-1.7-0.5-3.3-1.4-4.6l3.6-5.1 c5.5,2.7,10.2,6.8,13.1,9.8C51.5,36.8,42.2,44.6,32,44.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.b76c7aacf74829a50d5ed83131dddc23.svg";
export { ForwardRef as ReactComponent };